import React, { useState } from "react";
import { useLang } from "@/contexts/LangContext";
import { api, formatApiErrorDetail } from "@/lib/api";
import { t } from "@/lib/i18n";
import { toast } from "sonner";

const inputCls = "mt-2 w-full border border-[#E9ECEF] bg-[#F8F9FA] px-4 py-3 focus:outline-none focus:border-[#0A1128]";
const labelCls = "text-xs tracking-[0.18em] uppercase text-[#868E96]";

export const ChangePasswordCard = () => {
  const { lang } = useLang();
  const [form, setForm] = useState({ current_password: "", new_password: "" });
  const [saving, setSaving] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      await api.put("/auth/password", form);
      setForm({ current_password: "", new_password: "" });
      toast.success(t(lang, "settings.passwordUpdated"));
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally { setSaving(false); }
  };

  return (
    <div className="mt-8 max-w-xl bg-white border border-[#E9ECEF] p-6" data-testid="change-password-card">
      <h2 className="text-xs tracking-[0.24em] uppercase text-[#868E96]">{t(lang, "settings.password")}</h2>
      <form onSubmit={submit} className="mt-4 space-y-4">
        <div>
          <label className={labelCls}>{t(lang, "settings.currentPassword")}</label>
          <input type="password" required data-testid="settings-current-password" value={form.current_password} onChange={(e) => setForm({ ...form, current_password: e.target.value })} className={inputCls} />
        </div>
        <div>
          <label className={labelCls}>{t(lang, "settings.newPassword")}</label>
          <input type="password" required minLength={8} data-testid="settings-new-password" value={form.new_password} onChange={(e) => setForm({ ...form, new_password: e.target.value })} className={inputCls} />
        </div>
        <button type="submit" disabled={saving} className="bg-[#0A1128] text-white px-6 py-3 hover:bg-[#1C2538] disabled:opacity-60" data-testid="settings-password-btn">
          {saving ? t(lang, "common.loading") : t(lang, "settings.updatePassword")}
        </button>
      </form>
    </div>
  );
};
